import React from 'react';
import { QuestionComponentProps, QuestionData } from './type';
import FillInTheBlank_Results from './components/FillInTheBlank/FillInTheBlank_Results';
import MultipleChoice_Results from './components/MultipleChoice/MultipleChoice_Results';
import Unscramble_Results from './components/Unscramble/Unscramble_Results';
import TickTF_Results from './components/TickTF/TickTF_Results';
import Combine_Results from './components/Combine/Combine_Results';

type Props = {
  questions: QuestionData[];
};

const AnswersAndFiles = ({ questions }: Props) => {
  const QuestionAnswers = ({ question, index }: { question: QuestionData; index: number }) => {
    const componentType = (question.type ?? '').toUpperCase();
    const data: QuestionComponentProps = {
      questionIndex: index,
      questionData: question,
      isCombineChild: false,
    };
    switch (componentType) {
      case 'FILLINTHEBLANK':
        return <FillInTheBlank_Results {...data} />;
      case 'MULTIPLECHOICE':
        return <MultipleChoice_Results {...data} />;
      case 'UNSCRAMBLE':
        return <Unscramble_Results {...data} />;
      case 'TICKTF':
        return <TickTF_Results {...data} />;
      case 'COMBINEWITHAUDIO':
      case 'COMBINEWITHVIDEO':
        return <Combine_Results {...data} />;
      default:
        return <></>;
    }
  };
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 20 }}>--- ĐÁP ÁN VÀ FILE ĐÍNH KÈM ---</div>
      <div>
        {questions.map((question, index) => (
          <QuestionAnswers index={index} question={question} />
        ))}
      </div>
    </div>
  );
};

export default AnswersAndFiles;
